import { createLogic } from 'redux-logic';
import { Auth } from 'aws-amplify';
import ActionTypes from '../../ActionsTypes';
var fetchSession = createLogic({
  type: ActionTypes.GET_USER_ROLE,
  latest: true,
  process: function process(_ref) {
    var action = _ref.action,
        dispatch = _ref.dispatch;

    try {
      var saveRole = action.payload.saveRole;
      Auth.currentAuthenticatedUser({
        bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data

      }).then(function (user) {
        saveRole(user.signInUserSession.idToken.payload['cognito:groups']);
      }).catch(function (err) {
        return console.log(err);
      }); // eslint-disable-line
    } catch (error) {
      console.log(':( ', error); // eslint-disable-line
    }
  }
});
export default [fetchSession];